import { Box, Text } from '@youversion/design-system-components';
import BankAccountIcon from 'components/ui/icons/BankAccount';
import BankRoutingIcon from 'components/ui/icons/BankRouting';
import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';
import { keyCodes } from 'utils/constants';

interface Props {
  onChange: (change: { [key: string]: string }) => void;
}

export interface BankAccount {
  accountNumber: string;
  routingNumber: string;
}

const inputClasses = `
  rounded-1 border-small border-solid flex flex-row relative
  focus-within:border-transparent focus-within:outline-2 focus-within:outline-info focus-within:outline
  focus-within:dark:border-transparent focus-within:dark:outline-info-dark
  border-tertiary-light dark:border-tertiary-dark text-text-white dark:text-text-dark
  dark:bg-canvas-secondary-dark bg-white overflow-hidden h-[56px] pis-2 pie-2 pbs-2 pbe-2
  invalid:border-yv-red
`;
export default function PaymentMethodsBank({ onChange }: Props) {
  const { t } = useTranslation('common');
  const handleChange = useCallback(
    (evt: React.FormEvent<HTMLInputElement>) => {
      const elm = evt.currentTarget;
      elm.checkValidity();
      onChange({
        [elm.name]: elm.value,
      });
    },
    [onChange]
  );

  return (
    <Box>
      <label className='flex flex-col mbe-3'>
        <Box className='flex justify-between mbe-1'>
          <Text className='uppercase'>{t('giving.labels.routing_number')}</Text>
          <Box className='flex items-center'>
            <BankRoutingIcon className='mie-1' />
            <Text>123456789</Text>
            <BankRoutingIcon className='mis-1' />
          </Box>
        </Box>
        <input
          className={inputClasses}
          inputMode='numeric'
          maxLength={9}
          minLength={9}
          name='routingNumber'
          onChange={handleChange}
          type='text'
        />
      </label>

      <label className='flex flex-col'>
        <Box className='flex justify-between mbe-1'>
          <Text className='uppercase'>{t('giving.labels.account_number')}</Text>
          <Box className='flex items-center'>
            <Text>000123456789</Text>
            <BankAccountIcon className='mis-1' />
          </Box>
        </Box>
        <input
          className={inputClasses}
          inputMode='numeric'
          name='accountNumber'
          onChange={handleChange}
          onKeyDown={e => {
            if (e.key === keyCodes.ENTER) {
              e.currentTarget.blur();
            }
          }}
          type='text'
        />
      </label>
    </Box>
  );
}
